module.exports = __webpack_public_path__ + "static/media/mini-code.1afeb0dd.png";